export default __webpack_public_path__ + "static/hero-d@2x-a1143a35476fd604e9155f0d72dd53cc.webp";